import { createRouter, createWebHistory } from 'vue-router'
import LogIn from '../views/LogIn.vue'
import store from '../store'
import Information from '../views/Information.vue'
import OrdersProgress from '../views/OrdersProgress.vue'
import OrdersPending from '../views/OrdersPending.vue'
import OrdersDelivered from '../views/OrdersDelivered.vue'
import EditShipment from '../views/EditShipment.vue'
import Tracking from '../views/Tracking.vue'
import Users from '../views/Users.vue'
import Servicepoints from '../views/Servicepoints.vue'
import Statistics from '../views/Statistics.vue'
import Invoices from '../views/Invoices.vue'
import Refunds from '../views/Refunds.vue'
import AutoFacturations from '../views/AutoFacturations.vue'
import CashPayments from '../views/CashPayments.vue'
import AccountingCode from '../views/AccountingCode.vue'
import Clients from '../views/Clients.vue'
import Reports from '@/views/Reports.vue'
import Transporters from '@/views/Transporters.vue'
import CreateAWB from '@/views/CreateAWB.vue'
import CreatePICKUP from '@/views/CreatePICKUP.vue'
import ActionHistory from '@/views/ActionHistory.vue'
import PendingShipmentControl from '@/views/PendingShipmentControl.vue'
import CashAlerts from '@/views/CashAlerts.vue'
import CollectorDashboard from '@/views/CollectorDashboard.vue'
import OfficeDashboard from '@/views/OfficeDashboard.vue'
import CollectionSheet from '@/views/CollectionSheet.vue'
import Security from '@/views/Security.vue'


const routes = [
  {
    path: '/',
    name: 'Home',
    component: LogIn
  },
  {
    path: '/login',
    name: 'LogIn',
    component: LogIn
  },
  {
    path: '/information',
    name: 'Information',
    component: Information,
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/shipments-progress',
    name: 'OrdersProgress',
    component: OrdersProgress,
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/shipments-pending',
    name: 'OrdersPending',
    component: OrdersPending,
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/shipments-delivered',
    name: 'OrdersDelivered',
    component: OrdersDelivered,
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/historique-annulations',
    name: 'ActionHistory',
    component: ActionHistory,
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/pending-shipment/:shipment_id',
    name: 'PendingShipmentControl',
    component: PendingShipmentControl,
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/edit/shipment/:shipment_id',
    name: 'EditShipment',
    component: EditShipment,
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/track',
    name: 'Tracking1',
    component: Tracking
  },
  {
    path: '/track/:shipment_id',
    name: 'Tracking2',
    component: Tracking
  },
  {
    path: '/users',
    name: 'Users',
    component: Users,
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/service-points',
    name: 'Servicepoints',
    component: Servicepoints,
    meta: {
      requireLogin: true
    }
  },
    {
    path: '/security',
    name: 'Security',
    component: Security,
    meta: { requireLogin: true }
  },
{
    path: '/statistics',
    name: 'Statistics',
    component: Statistics,
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/accounting-code',
    name: 'AccountingCode',
    component: AccountingCode,
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/invoices',
    name: 'Invoices',
    component: Invoices,
    meta: {
      requireLogin: true,
      requireAccounting: true
    }
  },
  {
    path: '/cash-payments',
    name: 'CashPayments',
    component: CashPayments,
    meta: {
      requireLogin: true,
      requireAccounting: true
    }
  },
  {
    path: '/refunds',
    name: 'Refunds',
    component: Refunds,
    meta: {
      requireLogin: true,
      requireAccounting: true
    }
  },
  {
    path: '/auto-facturations',
    name: 'AutoFacturations',
    component: AutoFacturations,
    meta: {
      requireLogin: true,
      requireAccounting: true
    }
  },
  {
    path: '/reports',
    name: 'Reports',
    component: Reports,
    meta: {
      requireLogin: true,
      requireAccounting: true
    }
  },
  {
    path: '/collection-sheet',
    name: 'CollectionSheet',
    component: CollectionSheet,
    meta: { requireLogin: true }
  },
  {
    path: '/office-dashboard',
    name: 'OfficeDashboard',
    component: OfficeDashboard,
    meta: { requireLogin: true }
  },
  {
    path: '/collector-dashboard',
    name: 'CollectorDashboard',
    component: CollectorDashboard,
    meta: { requireLogin: true }
  },
  {
    path: '/cash-alerts',
    name: 'CashAlerts',
    component: CashAlerts,
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/transporters',
    name: 'Transporters',
    component: Transporters,
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/clients',
    name: 'Clients',
    component: Clients,
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/create-awb/:shipment_id',
    name: 'CreateAWB',
    component: CreateAWB,
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/create-pickup/:shipment_id',
    name: 'CreatePICKUP',
    component: CreatePICKUP,
    meta: {
      requireLogin: true
    }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requireLogin) && !store.state.isAuthenticated) {
    next({ name: 'LogIn', query: { to: to.path } })
    return
  }
  if (to.matched.some(record => record.meta.requireAccounting) && !store.state.accountingToken) {
    next({ name: 'AccountingCode', query: { next: to.fullPath } })
    return
  }
  next()
})

// À chaque changement de page on efface le bandeau d'erreur de la page précédente —
// sauf en arrivant sur la connexion, où « session expirée » doit rester lisible.
router.afterEach((to) => {
  if (to.name !== 'LogIn' && store.state.apiError) store.commit('setApiError', null)
})

export default router
